import * as sessionSelectors from 'app_modules/session/selectors'
import actionTypes from 'app_modules/profile/constants'
import { fetchWorkingCircleNotifications } from 'app_modules/notifications/actions/fetchWorkingCircleNotifications'
import api from 'api'

export const fetchAddWorkingCircleMemberRequest = () => ({
  type: actionTypes.FETCH_ADD_WORKING_CIRCLE_MEMBER_REQUEST,
})

export const fetchAddWorkingCircleMemberSuccess = response => ({
  payload: response,
  type: actionTypes.FETCH_ADD_WORKING_CIRCLE_MEMBER_SUCCESS,
})

export const fetchAddWorkingCircleMemberFailure = error => ({
  payload: error,
  type: actionTypes.FETCH_ADD_WORKING_CIRCLE_MEMBER_FAILURE,
})

/**
 * POST /account/:accountId/profiles/working_circle
 * Adds a profile to the current user's working circle.
 * Fires immediately on selection — no batching.
 *
 * @param {number}   profileId - The profile ID to add.
 * @param {function} onSuccess - Called on 200 OK.
 * @param {function} onError
 */
export const fetchAddWorkingCircleMember = (profileId, onSuccess, onError) => {
  const thunk = (dispatch, getState) => {
    const accountId = sessionSelectors.accountId(getState())

    dispatch(fetchAddWorkingCircleMemberRequest())

    const handleResponse = response => {
      dispatch(fetchAddWorkingCircleMemberSuccess(response))
      // Re-fetch notifications so the state is authoritative after the BE cache bust.
      // This also cancels any stale in-flight re-fetch triggered by a prior remove.
      dispatch(fetchWorkingCircleNotifications())
      if (onSuccess) onSuccess(response)
    }

    const handleError = ({ error }) => {
      dispatch(fetchAddWorkingCircleMemberFailure(error))
      if (onError) onError(error)
      else throw error
    }

    return api.profiles.addWorkingCircleMember({ accountId, profileId }, handleResponse, handleError)
  }

  thunk.type = actionTypes.FETCH_ADD_WORKING_CIRCLE_MEMBER

  return thunk
}

export default fetchAddWorkingCircleMember
